import stepGroups from "./stepGroups";

export const getStepGroup = (stepId?: string) => {
  if (!stepId) return null;

  return Object.keys(stepGroups).find((key) =>
    stepGroups[key].includes(stepId)
  );
};
